const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();

      // Re-initialize tooltips after loading new products
      if (window.simpleTooltipHandler) {
        setTimeout(() => {
          window.simpleTooltipHandler.refresh();
        }, 100);
      }

      // Re-initialize wishlist icons after loading new products
      // The iwish app needs to inject content (spans/SVG) into the .iwishcheck elements

      // Remove 'loaded' class from newly loaded icons so app can process them
      // Use requestAnimationFrame for better performance
      requestAnimationFrame(() => {
        const newlyLoadedIcons = document.querySelectorAll('.load-more-grid .list-product-icon');
        newlyLoadedIcons.forEach(icon => {
          // Only remove loaded if icon is empty (no content injected yet)
          if (icon.children.length === 0 && icon.innerHTML.trim().length === 0) {
            icon.classList.remove('loaded');
          }
        });
      });

      // Restart the wishlist app's checking mechanism
      if (typeof window.restartWishlistCheck === 'function') {
        setTimeout(() => {
          window.restartWishlistCheck();
        }, 200);
      }

      // Wait for iwish app to inject content into the icons
      function initializeWishlistIcons(attempt = 1, maxAttempts = 15) {
        // Find icons that don't have content yet (not loaded OR loaded but empty)
        const allIcons = document.querySelectorAll('.load-more-grid .list-product-icon');
        const newWishlistIcons = Array.from(allIcons).filter(icon => {
          // Include icons that are either not loaded, or loaded but empty
          return !icon.classList.contains('loaded') ||
            (icon.children.length === 0 && icon.innerHTML.trim().length === 0);
        });

        if (newWishlistIcons.length === 0) {
          return; // All icons have content
        }

        // Check if app has injected content (any child elements)
        const iconsWithContent = newWishlistIcons.filter(icon => {
          return icon.children.length > 0 || icon.innerHTML.trim().length > 0;
        });

        // Only mark as loaded if app has actually injected content
        iconsWithContent.forEach((icon) => {
          if (icon.children.length > 0 || icon.innerHTML.trim().length > 0) {
            icon.classList.add('loaded');
          }
        });

        // If we found content, trigger update events
        if (iconsWithContent.length > 0) {
          if (typeof document.dispatchEvent !== 'undefined') {
            document.dispatchEvent(new CustomEvent('iwishUpdated'));
            document.dispatchEvent(new CustomEvent('wishlistUpdated'));
          }
        }

        // Trigger iwish app to process new elements (only on first few attempts)
        if (attempt <= 3 && typeof window.iWish !== 'undefined') {
          // Try to trigger iwish app to process new elements
          if (typeof window.iWish.iWishsync === 'function') {
            try {
              window.iWish.iWishsync();
            } catch (e) {
              // Silent fail
            }
          } else if (window.iWish.iWishsync && typeof window.iWish.iWishsync === 'object' && typeof window.iWish.iWishsync.call === 'function') {
            try {
              window.iWish.iWishsync.call(window.iWish);
            } catch (e) {
              // Silent fail
            }
          }

          // Dispatch DOMContentLoaded event to trigger app detection
          try {
            document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true }));
          } catch (e) {
            // Silent fail
          }
        }

        // If not all icons have content and we haven't exhausted retries, try again
        if (iconsWithContent.length < newWishlistIcons.length && attempt < maxAttempts) {
          const nextDelay = attempt === 1 ? 300 : attempt < 5 ? 500 : 1000;

          // Restart the check function periodically to keep it active
          if (attempt % 5 === 0 && typeof window.restartWishlistCheck === 'function') {
            window.restartWishlistCheck();
          }

          setTimeout(() => {
            initializeWishlistIcons(attempt + 1, maxAttempts);
          }, nextDelay);
        }
      }

      // Use MutationObserver to watch for when app injects content into icons
      let wishlistObserver = null;
      let observerTimeout = null;

      const loadMoreGrid = document.querySelector('.load-more-grid');
      if (loadMoreGrid) {
        wishlistObserver = new MutationObserver((mutations) => {
          let hasUpdates = false;

          mutations.forEach((mutation) => {
            // Check for added nodes (when app injects content)
            if (mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                  // Find the parent icon efficiently
                  const icon = node.closest ? node.closest('.list-product-icon') : null;

                  if (icon && !icon.classList.contains('loaded')) {
                    // Check if icon now has content
                    if (icon.children.length > 0 || icon.innerHTML.trim().length > 0) {
                      icon.classList.add('loaded');
                      hasUpdates = true;
                    }
                  }
                }
              });
            }
          });

          // If we detected updates, trigger events
          if (hasUpdates) {
            if (typeof document.dispatchEvent !== 'undefined') {
              document.dispatchEvent(new CustomEvent('iwishUpdated'));
              document.dispatchEvent(new CustomEvent('wishlistUpdated'));
            }
          }
        });

        wishlistObserver.observe(loadMoreGrid, {
          childList: true,
          subtree: true,
          characterData: false
        });

        // Clean up observer after reasonable time
        observerTimeout = setTimeout(() => {
          if (wishlistObserver) {
            wishlistObserver.disconnect();
            wishlistObserver = null;
          }
        }, 20000);
      }

      // Start initialization after initial delay to allow DOM to settle
      setTimeout(() => {
        initializeWishlistIcons();
      }, 500);

      // Process new omnibus containers after loading new products
      if (window.processNewOmnibusContainers) {
        setTimeout(() => {
          window.processNewOmnibusContainers();
        }, 100);
      }
    },
    complete: function () {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();